import ROUTES from '../routes';
import NewApplication from '../hoc/new-application';
import NewApplcationList from '../hoc/new-application/list';
import NewApplicationIndividualInfo from '../hoc/new-application/individual/info';
import NewApplicationCorporateInfo from '../hoc/new-application/corporate/info';
import NewApplicationMainRepresentativeInfo from '../hoc/new-application/main-representative/info';
import Agreement from '../hoc/common/documents/parts/agreement';
import DocumentPanel from '../hoc/new-application/common/document-panel';
import { ApplicationType } from '../hoc/new-application/types';
import { OrganizationType } from '../hoc/common/types';

const NewAppliation = {
  path: ROUTES.CUSTOMERS_NEW_APPLICATION,
  element: <NewApplication />,
  children: [
    {
      path: ROUTES.CUSTOMERS_NEW_APPLICATION_LIST,
      element: <NewApplcationList />,
    },
    {
      path: ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_INFO,
      element: <NewApplicationIndividualInfo />,
      children: [
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_AGREEMENT,
          element: (
            <Agreement
              customerType={ApplicationType.INDIVIDUAL}
              isApplication
            />
          ),
        },
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_DOCUMENT,
          element: <DocumentPanel clientType={OrganizationType.INDIVIDUAL} />,
        },
      ],
    },
    {
      path: ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_INFO,
      element: <NewApplicationCorporateInfo />,
      children: [
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_AGREEMENT,
          element: (
            <Agreement customerType={ApplicationType.CORPORATE} isApplication />
          ),
        },
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_DOCUMENT,
          element: (
            <DocumentPanel
              clientType={OrganizationType.CORPORATE}
              isCorporate
            />
          ),
        },
      ],
    },

    {
      path: ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL,
      element: <NewApplicationMainRepresentativeInfo isCompanyOfficial />,
      children: [
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL_AGREEMENT,
          element: (
            <Agreement
              customerType={ApplicationType.COMPANY_OFFICIAL}
              isApplication
            />
          ),
        },
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL_DOCUMENT,
          element: (
            <DocumentPanel clientType={OrganizationType.INDIVIDUAL} isCof />
          ),
        },
      ],
    },
  ],
};

export default NewAppliation;
